// src/schemas/registrationSchemas.ts
import { z } from 'zod';

export const contactDetailsSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  mobile: z.string().optional(),
  relationshipManager: z.string().optional(),
});

export const businessDetailsSchema = z.object({
  panCard: z.instanceof(File).nullable().optional(),
  panNumber: z.string().min(10, 'PAN number must be 10 characters').max(10).optional(),
  operatingAddress: z.string().min(1, 'Operating address is required').optional(),
  brandName: z.string().optional(),
  category: z.string().optional(),
  businessType: z.enum(['business', 'individual']).optional(),
});

export const ownerDetailsSchema = z.object({
  panNumber: z.string().min(10).max(10).optional(),
  aadhaarNumber: z.string().min(12, 'Aadhaar number must be 12 digits').max(12, 'Aadhaar number must be 12 digits').optional(),
});

export const productSelectionSchema = z.object({
  products: z.array(z.string()).min(1, 'Select at least one product'),
  remittanceMargins: z.object({
    educationPayment: z.number().min(0).max(100),
    studyMaintenance: z.number().min(0).max(100),
    giftFamily: z.number().min(0).max(100),
  }).optional(),
});

export const addressSchema = z.object({
  pinCode: z.string().regex(/^\d{6}$/, 'Invalid PIN code'),
  addressLine1: z.string().min(1, 'Address line 1 is required'),
  addressLine2: z.string().optional(),
  propertyType: z.enum(['owned', 'rented']),
  electricityBill: z.instanceof(File).optional(),
  premiseImages: z.array(z.instanceof(File)).optional(),
});